import React, { } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const columns = [
  { id: 'trabajador', label: 'Trabajador', minWidth: 250, align: 'left', },
  { id: 'numdoc', label: 'DNI', minWidth: 100, align: 'left', },
  { id: 'desJefe', label: 'Jefe', minWidth: 250, align: 'left', },
  { id: 'desTipoEquipo', label: 'Equipo', minWidth: 150, align: 'left', },
  { id: 'codigoDefinitivo', label: 'Codigo', minWidth: 150, align: 'left', },
  { id: 'centroCosto', label: 'Operación', minWidth: 150, align: 'left', },
  { id: 'marca', label: 'Marca', minWidth: 100, align: 'left', },
  { id: 'modelo', label: 'Modelo', minWidth: 150, align: 'left', },
  { id: 'desEstado', label: 'Estado', minWidth: 100, align: 'left', },
  { id: 'departamento', label: 'Departamento', minWidth: 100, align: 'left', },
  { id: 'otros', label: 'Otros datos', minWidth: 200, align: 'left', },
  { id: 'fechaIngreso', label: 'Fecha', minWidth: 120, align: 'left', },

];

const BodyEquipementView = (props) => {
  const { equipoRecibido } = props;


  return (
    <div className='page-body-main'>
      <div className='page-body__table' style={{ overflow: 'hidden' }}>
        <div className='page-body-table'>
          <TableContainer className='table-height'>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {equipoRecibido?.map((record, indexRow) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={"row" + indexRow}>
                      {columns.map((column, indexColumn) => {
                        const value = record[column.id];
                        return (
                          <TableCell key={'col' + indexColumn} align={column.align}>
                            {column.id === 'fechaIngreso' && value
                              ? value.substring(0, 10)
                              : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}
export default BodyEquipementView;